import { packagingTypes } from '@fv/models'

export const clientPackagingTypes = [
  ...packagingTypes.map(t => t.key),
  'pallet-48x40',
  'pallet-48x48',
  'pallet-60x40',
] as const
export type ClientPackagingType = (typeof clientPackagingTypes)[number]
